import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Menu, Title, Item, SubMenuItem } from './styles'
import Cross from 'assets/svg/cross.svg'

const MainNav = ({
  popUpRef,
  open,
  setOpen
}) => {

  const navigate = useNavigate();
  const { pathname } = useLocation()

  const MENU_ITEMS = [
    {
      title: 'HOME',
      to: '/floor/8',
    },
    {
      title: 'PARKING',
      to: '/parking',
    },
    {
      title: 'BOOKINGS',
      to: '/bookings',
      subMenu: [
        {
          title: 'Create Booking',
          to: '/create-booking',
        },
      ],
    },
    {
      title: 'STAFF',
      to: '/staff',
    },
    {
      title: 'REPORTS',
      to: '/reports',
      subMenu: [
        {
          title: 'Occupancy Report',
          to: '/reports/occupancy',
        },
        {
          title: 'Revenue Report',
          to: '/reports/revenue',
        },
        {
          title: 'Daily Reconciliation',
          to: '/reports/daily-reconciliation',
        },
        {
          title: 'Bookings Report',
          to: '/reports/bookings',
        },
        {
          title: 'Price Table',
          to: '/reports/price-table',
        },
      ],
    }
  ];

  return (
    <Menu
      open={open}
      ref={popUpRef}
    >
      <Title>
        <img
          src={Cross}
          alt="cross"
          onClick={()=>{
            setOpen(false)
          }}
        />
      </Title>
      {
        MENU_ITEMS.map((item, index) => {
          const { title, to, subMenu } = item
          return (
            <React.Fragment key={index}>
              {
                <>
                  <Item
                    className={to === pathname? 'active':''}
                    to={to}
                    onClick={() => {
                      setOpen(false)
                    }}            
                  >
                    {title}
                  </Item>
                  {
                    subMenu?.map(({ title, to }, i) => (
                      <SubMenuItem
                        key={i}
                        className={to === pathname? 'active':''}
                        to={to}        
                        onClick={() => {
                          setOpen(false)
                        }}
                      >
                        {title}
                      </SubMenuItem>
                    ))
                  }
                </>
              }
            </React.Fragment>
          )
        })
      }
    </Menu>
  );
}

export default MainNav;
